import React, { useState } from 'react';
import { LinkedInManager } from '@copilot/data';
import { useDispatch } from 'react-redux';
import { LinkedinActions } from '@copilot/common/store/actions/linkedin';
import { MemberLinkedInProfileResponse } from '@copilot/data/responses/interface';

export const useContactLinkedinProfile = (
    orgId: string,
    memberId: string
): MemberLinkedInProfileResponse | undefined => {
    const [profile, setProfile] = useState<MemberLinkedInProfileResponse>();
    const storeDispatch = useDispatch();

    React.useEffect(() => {
        if (orgId == '') return;
        orgId &&
            memberId &&
            LinkedInManager.getContactLinkedInProfile(orgId, memberId).then((contactProfile) => {
                setProfile(contactProfile);
                storeDispatch(LinkedinActions.loadMemberLinkedinProfile(contactProfile));
            });
    }, [orgId, memberId]);

    return profile;
};
